<template>
  <div>
    <el-carousel height="800px" class="carousel" data-aos="zoom-in">
      <el-carousel-item v-for="(item,index) in carousel" :key="index">
         <img :src="item.src" style="width:100%;">
      </el-carousel-item>
    </el-carousel>
    <div class="introduce" data-aos="flip-up">
        <div v-for="item in introduce"  :key="item.title">
            <div class="introduceImg"><img :src="item.src" alt=""></div>
            <div class="introduceText">
              <span>{{ item.title }}</span>
              <span>{{ item.name }}</span>
            </div>
        </div>
    </div>
    <!-- 公司历程 -->
    <div  class="history">
      <div class="historyTitle"  data-aos="fade-up">公司历程</div>
      <div class="historyContent">
        <div class="historyText">
          <div data-aos="fade-right" style="width: 180px;padding-left: 120px;">
            唐颐信息子公司无锡众信科技有限公司成立，与我国十家大型三甲医院开展合作，包括301医院、武汉协和医院、中山大学附属第一医院等。
          </div>
          <div data-aos="fade-right" style="width: 240px;padding-left: 130px;padding-top: 10px;">
            唐颐信息与上海市东方医院合作开发了“干细胞临床研究信息化管理平台”;公司参与“十三五”国家重点研发计划。
          </div>
          <div data-aos="fade-left" style="width: 184px;padding-left: 116px;padding-top: 75px;">
            刘雷教授当选国际健康科学信息学研究院(IAHSI)院士；唐颐信息入选“中国干细胞产业联盟”理事单位。
          </div>
          <div data-aos="fade-left" style="width: 200px;padding-left: 136px;padding-top: 113px;">
            《干细胞临床研究信息管理规范》团体标准在全国团体标准信息平台公布实施，唐颐信息作为起草单位参与标准制定。
          </div>
        </div>
        <img :src="require('@/assets/img/home/history1.png')" alt="" width="1329" style="margin: 52px 0;" data-aos="flip-up">
        <div class="historyText">
          <div data-aos="fade-right"  style="width: 173px;padding-left: 15px;">
            公司首席科学顾问刘雷教授入选“中国科学院百人计划”，同年承担国家863与上海市重大专项。
          </div>
          <div data-aos="fade-right" data-wow-duration="2s" style="width: 150px;padding-left: 122px;">
            刘雷教授作为项目首席，承担国家重点研发计划“精准医学研究”重点专项：疾病研究精准医学知识库构建（项目编号：2016YFC0901900）
          </div>
          <div data-aos="fade-left" style="width: 160px;padding-left: 136px;">
            唐颐信息入选中国研究型医院学会临床数据与样本资源库专业委员会委员单位；刘雷教授与公司CEO唐万,分别当选专委会副主任委员、信息组学秘书长。
          </div>
          <div data-aos="fade-left" style="width: 160px;padding-left: 230px;">
            唐颐信息入驻“数字健康新质生产力服务平台”，成为首批入驻的数字健康领域供给侧企业。
          </div>
        </div>
      </div>
    </div>
    <!-- 核心产品 -->
    <div class="products">
      <div class="productsTitle" data-aos="fade-up">核心产品</div>
      <div class="productsContent">
        <div class="productsLeft">
          <el-menu
            defaultActive="0"
            class="el-menu-vertical-demo"
            text-color="#333"
            active-text-color="#fff"
            @select="productsSelect">
            <el-menu-item v-for="(item,index) in productsList" :key="index" :index="index.toString()" data-aos="fade-right">
              {{ item.title }}<i class="el-icon-caret-right" :style="{display:productsIndex===index?'block':'none'}"></i>
            </el-menu-item>
          </el-menu>
        </div>
        <div class="productsRight">
          <div class="productsRightTitle" data-aos="zoom-in">{{ productsList[productsIndex].title }}</div>
          <div data-aos="fade-left" style="width: 54px;height: 8px;background: #ed1d25;margin:25px 0;"></div>
          <img :src="productsList[productsIndex].src" :alt="productsList[productsIndex].title"  data-aos="zoom-in">
          <div v-html="productsList[productsIndex].content" class="productsRightContent"></div>
          <div style="position: absolute;bottom: 0;right: 0;width: 54px;height: 8px;background: #ed1d25;"></div>
        </div>
      </div>
    </div>
    <!-- 典型案例 -->
    <div class="case">
      <div class="caseTitle" data-aos="fade-up">典型案例</div>
      <div class="caseContent">
          <div v-for="(item,index) in caseList" :key="'case'+index" :data-aos="index%2==0?'fade-right':'fade-left'" >
              <img :src="item.src" alt="" style="width: 100%;height:288px">
              <div class="caseListTitle" v-html="item.title"></div>
              <div  class="caseContentText">
                <div v-html="item.title"></div>
                <div v-html="item.content"></div>
              </div>
          </div>
      </div>
      <div class="caseMore">
          <router-link to="/case/hospital" data-aos="fade-left"> 更多案例<i class="el-icon-caret-right"></i></router-link>
      </div>
    </div>
    <!-- 公司资质 -->
    <div class="qualification">
      <div class="qualificationTitle" data-aos="fade-up">资质荣誉</div>
      <div class="qualificationContent">
        <div class="prev" data-aos="fade-right">
          <i class="el-icon-arrow-left"></i>
        </div>
        <swiper :options="swiperOption" ref="mySwiper" data-aos="zoom-in">
            <swiper-slide v-for="(item,index) in qualificationList" :key="'qualification'+index" >
                <img :src="item.src" alt="" style="width: 100%;">
            </swiper-slide>
        </swiper>
        <div class="next" data-aos="fade-left">
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
    </div>
    <div class="news">
      <div class="news_title" >
        <img src="@/assets/img/news/img.png" width="300" />
      </div>

      <div class="news_select" >
        <div :class="radio === '1'?'radio-button red':'radio-button'">公司新闻</div>
        <div :class="radio === '2'?'radio-button red':'radio-button'">行业新闻</div>
      </div>
      <div class="news-card-list" >
        <template v-for="(item,index) in cardList">
          <el-card :body-style="{ padding: '0px',cursor:'pointer'}" style="width:26%;margin-left: 2%;position: relative"  >
            <img :src="item.src" width="100%" @click="toNews(item)" />
            <div style="padding: 10px" @click="toNews(item)">
              <div>{{item.title}}</div>
              <div style="margin-top: 10px;font-size: 16px;height: 15px">
                <div style="position: absolute;bottom: 5px">{{item.date}}</div>
              </div>
            </div>
          </el-card>
        </template>
      </div>
      <div class="news-more" >
        <div class="radio-button red" @click="toNews(null)" style="margin-right: 6%">查看更多<i class="el-icon-caret-right" style="font-size: 24px;color: white" /></div>
      </div>
<!--      <el-row>-->
<!--        <el-col :span="3"> </el-col>-->
<!--        <el-col :span="6" v-for="(o, index) in 2" :key="o">-->
<!--          <el-card :body-style="{ padding: '0px' }">-->
<!--            <img src="https://shadow.elemecdn.com/app/element/hamburger.9cf7b091-55e9-11e9-a976-7f4d0b07eef6.png" class="image">-->
<!--            <div style="padding: 14px;">-->
<!--              <span>好吃的汉堡</span>-->
<!--            </div>-->
<!--          </el-card>-->
<!--        </el-col>-->
<!--      </el-row>-->
    </div>
  </div>
</template>

<script>
import WOW from '../../node_modules/wowjs/dist/wow';
export default {
  name:'home',
  components:{
  },
  data () {
    return {
      radio:'1',
      cardList:[
        {src:require('@/assets/news/9.jpg'),title:'聚焦精准医疗，共话创新未来！唐颐信息精彩亮相2025中国研究型医院学会临床数据与样本资源库专业委员会学术年会',date:'2025-11-06',key:'9'},
        {src:require('@/assets/news/8.jpg'),title:'唐颐信息AI产品精彩亮相福建生物样本学术盛会，赋能精准医疗新发展',date:'2025-09-09',key:'8'},
        {src:require('@/assets/news/7.png'),title:'《干细胞临床研究信息管理规范》团体标准发布，唐颐信息助力干细胞临床研究高质量发展',date:'2025-07-31',key:'7'},
      ],
      carousel:[
        {
          src:require('@/assets/img/home/carousel1.jpg'),
        },
        {
          src:require('@/assets/img/home/carousel3.jpg'),
        },
        {
          src:require('@/assets/img/home/carousel2.jpg'),
        }
      ],
      introduce:[
        {
          title:'10余年',
          name:'研发经验',
          src:require('@/assets/img/home/introduce1.png'),
        },

        {
          title:'国家标准',
          name:'起草单位',
          src:require('@/assets/img/home/introduce3.png'),
        },
        {
          title:'行业协会',
          name:'成员单位',
          src:require('@/assets/img/home/introduce2.png'),
        },
        {
          title:'300+',
          name:'合作客户',
          src:require('@/assets/img/home/introduce4.png'),
        },
      ],
      productsIndex:'0',
      productsList:[
        {
          title:'BioFactory临床数据与样本资源库管理系统',
          src:require('@/assets/img/home/products_BioFactory.png'),
          content:'<p data-aos="fade-up">上海唐颐信息技术有限公司参与全国生物样本标准化技术委员会归口国家标准 GB/T 39766‑2021《人类生物样本库管理规范》的起草工作，负责其中信息化相关内容编制。核心团队历经15年行业积累，服务300余家客户，涵盖大型三甲医院、知名高校、科研院所、企业等不同类型机构，在大量项目实践中持续优化生物样本库相关产品，已完成8次版本迭代。</p><p data-aos="fade-up">BioFactory 临床数据与样本资源库管理系统，实现生物样本全生命周期的规范化管理，具备采集可追溯、信息化管理、质量管控、数据分析等能力，助力保障样本信息记录完整、规范与可追溯，支撑样本质量管控业务开展。系统包含旗舰版、专业版、基础版等5大版本，精准匹配不同机构的用户规模与功能需求，为科研工作者开展研究提供支撑，助力提升科研工作效率。</p>'
        },
        {
          title:'Ecell细胞生命周期信息管理系统',
          src:require('@/assets/img/home/products_Ecell.png'),
          content:'<p data-aos="fade-up">上海唐颐信息技术有限公司为上海干细胞产业联盟发起成员单位、《干细胞转化临床研究信息管理规范》参与起草单位。依托与多家三甲医院的项目合作实践，公司推出面向细胞制备、存储与临床研究应用的EH‑CLCMS细胞全生命周期信息化整体解决方案。</p><p data-aos="fade-up">作为信息化综合管理解决方案的重要组成部分，Ecell细胞全生命周期信息管理系统' +
                  '是基于细胞全生命周期的干细胞资源库大数据管理平台，包括实验室资源子系统、项目管理子系统、样本流转子系统、细胞制备子系统、细胞质检子系统，用于管理细胞采集、检测、制备、质控、运输、存储、放行、销毁等各个阶段的数据，360度全周期贯穿从细胞采集到应用等的全流程，保障细胞制剂质量和细胞治疗应用的规范化，满足客户对细胞实验研究与临床应用的管理需求。</p>'
        },
        {
          title:'BioCloud多中心生物样本资源共享平台',
          src:require('@/assets/img/home/products_BioCloud.png'),
          content:'<p data-aos="fade-up">BioCloud 多中心生物样本资源共享平台，是面向生物样本库之间开展资源共享与信息交流的信息管理系统。平台具备样本信息共享、资源互借、项目合作、信息交流、中心业务评价等功能，采用规范化整合机制，结合数据脱敏与加密手段，并对数据交互记录进行实时核对，强化样本信息完整性与隐私防护，支撑各生物样本库开展信息、资源与项目层面的交流互动，提升样本资源的利用率与使用效能。平台适配临床科研单位、药物研发企业、政府决策机构等多类使用主体，依托标准化应用与服务，助力打通跨机构、跨地区科研协作链路，为实现相关科学价值与社会价值提供支撑。</p>'
        },
        {
          title:'HoloData智能专病数据管理平台',
          src:require('@/assets/img/home/products_HoloData.png'),
          content:'<p data-aos="fade-up">oloData智能专病数据库管理平台，以临床业务信息系统或集成整合后的临床数据为数据源，经“抽取‑转换‑加载”处理形成标准资源库。在此基础上，依托自然语言处理、数据映射等技术构建专病数据库与课题数据库。主要功能模块包含数据采集、数据治理、统计分析、科研分析、课题研究、患者 360° 全息视图等。平台沉淀公司在医疗数据治理领域的实践经验，采用OHDSI提出的OMOP通用数据模型搭建大数据中心，运用隐私安全相关技术，助力数据合规价值释放；支持集成多源异构数据，依托数据标准化、AI数据治理能力落地数据应用，同时配备专业医学人才，可协助开展专病数据集制定、专病人群纳排梳理等工作，支撑科研业务开展，助力医疗机构科研能力建设，为医学成果转化提供技术支撑，服务行业健康发展需求。</p>'
        },
        {
          title:'BioOmics组学数据发布管理平台',
          src:require('@/assets/img/home/products_BioOmics.png'),
          content:'<p data-aos="fade-up">组学研究是后基因组时代生命科学发展的重要特征，开放共享的组学大数据已成为生命科学领域的重要研究资源，组学数据发布管理平台扮演数据生产者与数据用户之间的重要纽带。</p><p data-aos="fade-up">BioOmic 组学数据发布管理平台，是面向组学数据标准化提交、审核、发布和共享的信息管理系统。研究人员可通过平台提交基因组、转录组、蛋白质组、代谢组等相关数据，并完善数据来源、测序技术、生物学重复次数等元数据信息；经过元数据审核、数据发布、数据共享、知识挖掘等环节，完成组学研究数据的标准化提交、规范化审核与开放共享，提升组学数据与信息的可获取性、可重复性与可靠性，助力推动跨团队、跨学科交叉研究，为科研人员挖掘潜在生物学知识、探索前沿研究方向提供数据支撑。</p>'
        },
        {
          title:'BioTank专病精准医学知识图谱系统',
          src:require('@/assets/img/home/products_BioTank.png'),
          content:'<p data-aos="fade-up">BioTank专病精准医学知识图谱系统，是面向专病领域知识收集、管理与挖掘的人工智能科研信息系统。系统针对专病相关文献、临床数据、组学数据及公共数据库信息开展深度挖掘与知识提取，构建涵盖基因、蛋白、代谢产物、治疗策略等各类实体及其关联关系的知识网络，实现对疾病领域知识的系统性梳理与重构。<p data-aos="fade-up">依托知识网络及自研推理模型与算法，系统可对录入的临床表型与生物标记开展科研层面的分析解析，挖掘其与已知生物网络的对应关联，输出疾病风险分析提示、治疗靶点挖掘线索、药物候选筛选线索等科研参考信息，可为专病科研、靶点研究、药物研发等研究场景提供技术支撑。</p>'
        },
        {
          title:'iLab智慧实验室管理系统',
          src:require('@/assets/img/home/products_iLab.png'),
          content:'<p data-aos="fade-up">iLab智慧实验室管理系统将实验记录、试剂耗材、实验产物、库存管理、生产流程管理、数据处理等业务要素有机融合，包含电子记录、样品管理、项目管理、库存管理、数据管理、质量管理六大功能模块。系统支持多样化记录方式与灵活的模板定制，实现样品的全过程管理，实时展示实验室工作进展；可对库存数据、实验结果进行统一管理，支持与实验室内仪器设备数据对接整合，同时满足审计追踪及实验数据偏差管理的合规要求。</p><p data-aos="fade-up">系统对实验室多源繁杂的数据信息进行规范化梳理，助力破除数据孤岛，释放数据价值，助力提升实验室管理效率。</p>'
        }
      ],
      caseList:[
        {
          title:'中国人民解放军总医院医学创新研究部<br />临床生物样本中心',
          src:require('@/assets/img/home/case1.png'),
          content:'<p style="color:#fff">一期：建设临床数据与样本资源库管理系统(2012年---2014年)</p><p style="color:#fff">二期：整合样本数据及海量临床数据(2014年---2016年)</p><p style="color:#fff">三期：大数据整合应用管理(2016---至今)</p><p style="color:#fff">四期：整合实验室检测相关工作流程形成生物样本全流程闭环管理</p>'
        },
        {
          title:'复旦大学上海医学院医学科研数据中心',
          src:require('@/assets/img/home/case2.png'),
          content:'复旦大学上海医学院医学科研数据中心，依托GPU算力与海量存储底座，面向组学研究、医学数据挖掘、医学 AI 开展科研支撑，汇聚医学院实验室及附属医院临床科研数据，搭建医学科研‑临床数据互联互通的共享设施平台。上海唐颐信息技术有限公司为该中心提供相关信息化技术支撑服务，助力科研数据的管理、集成与共享应用。'
        },
        {
          title:'上海生物样本库',
          src:require('@/assets/img/home/case3.png'),
          content:'<p style="color:#fff">上海生物样本库（原上海张江生物银行）由上海浦东张江管委会立项，由生物芯片上海国家工程研究中心旗下上海芯超生物科技有限公司牵头承建。该样本库已取得科技部人类遗传资源保藏行政许可。</p><p style="color:#fff">上海唐颐信息技术有限公司为该样本库提供生物样本库信息管理系统，并与其合作研发第三方商业生物样本库管理平台，输出面向生物样本库场景的专业化大数据定制解决方案。</p>'
        },
        {
          title:'上海市东方医院干细胞临床研究信息管理平台',
          src:require('@/assets/img/home/case4.png'),
          content:'由东方医院牵头推进的干细胞转化产业基地项目获上海市批准，落户张江生物医药产业园区。该项目信息管理平台涵盖生物资源样本库、项目管理信息系统、临床资源库、实验室管理信息系统、细胞制备实验室信息管理系统、细胞治疗临床试验信息管理系统等子系统。上海唐颐信息技术有限公司为本项目提供相关信息化系统建设支撑。'
        },
      ],
      qualificationList:[
        {src:require('@/assets/img/soft/rz(1).jpeg')},
        {src:require('@/assets/img/soft/rz(1).jpg')},
        {src:require('@/assets/img/soft/rz(1).png')},
        {src:require('@/assets/img/soft/rz(2).jpeg')},
        {src:require('@/assets/img/soft/rz(2).jpg')},
        {src:require('@/assets/img/soft/rz(2).png')},
        {src:require('@/assets/img/soft/rz(3).jpeg')},
        {src:require('@/assets/img/soft/rz(3).jpg')},
        {src:require('@/assets/img/soft/rz(3).png')},
        {src:require('@/assets/img/soft/rz(4).jpeg')},
        {src:require('@/assets/img/soft/rz(4).jpg')},
        {src:require('@/assets/img/soft/rz(5).jpeg')},
        {src:require('@/assets/img/soft/rz(5).jpg')},
        {src:require('@/assets/img/soft/rz(6).jpg')},
        {src:require('@/assets/img/soft/rz(7).jpg')},
        {src:require('@/assets/img/soft/rz(8).jpg')},
        {src:require('@/assets/img/soft/rz(9).jpg')},
        {src:require('@/assets/img/soft/rz(10).jpg')},
        {src:require('@/assets/img/soft/rz(11).png')},
        {src:require('@/assets/img/soft/rz(12).jpg')},
      ],
      swiperOption:{
          navigation: {
            nextEl: ".next",
            prevEl: ".prev",
          },
          slidesPerView: 5,
          autoplay: {
            delay: 2000,
            disableOnInteraction: false,
          },
          direction: "horizontal",
          loop: true,
          centeredSlides: true,
          spaceBetween: 20,
          observer: true,
          observeParents: true,
      }
    }
  },
  mounted() {
    let wow = new WOW.WOW({
        boxClass: 'wow',
        animateClass: 'animated',
        offset: 0,
        mobile: true,
        live: true
      });
      wow.init();

      // window.addEventListener("scroll", this.scrolling)
  },
  methods: {
    productsSelect(index){
      this.productsIndex = index.toString()
    },
    scrolling() {
        // 滚动条距文档顶部的距离
        // let scrollTop = window.pageYOffset || document.documentElement.scrollTop ||
        //     document.body.scrollTop
        // // 滚动条滚动的距离
        // let scrollStep = scrollTop - this.oldScrollTop;
        // // 更新——滚动前，滚动条距文档顶部的距离
        // this.oldScrollTop = scrollTop;
        // let refs = document.getElementsByClassName('wow')
        // console.log(refs)
        // if (scrollStep < 0) {
        //     console.log("滚动条向上滚动了！")
        // } else {
        //     console.log("滚动条向下滚动了！")
        // }
    },
    toNews(val){
      console.log(val)
      if(val){
        this.$router.push({name:'newsItem',query:{key:val.key}})
      }else {
        this.$router.push('/about/news')
      }

    }
  }
}
</script>

<style lang="less" scoped>
  .carousel{
    /deep/
    .el-carousel__indicators--horizontal {
      li{
        .el-carousel__button{
          width: 14px;
          height: 14px;
          border-radius: 50%;
          background: #333333;
        }
      }
      .is-active{
        .el-carousel__button{
          background: #ed1d25;
        }
      }
    }
  }
  .introduce{
    width: 1200px;
    padding: 83px 120px 145px 130px;
    margin: 0 auto ;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    text-align: center;
    .introduceImg{
      height: 60px;
      line-height: 68px;
    }
    &>div:nth-child(3){
      .introduceImg{
          img{
            margin-top: -6px;
          }
      }

    }
    &>div:nth-child(4){
      .introduceImg{
        // padding-top: 2px;
        box-sizing: border-box;
      }

    }
    .introduceText{
      span{
        display: block;
        font-size: 14px;
        letter-spacing: 1px;
        -moz-transform: matrix( 1.54163205328771, 0, 0, 1.5416320532877, 0, 0);
        -webkit-transform: matrix( 1.54163205328771, 0, 0, 1.5416320532877, 0, 0);
        line-height: 2.205;
      }
      &>span:nth-child(1){
        font-weight: 500;
      }
      &>span:nth-child(2){
        font-weight: 400;
      }
    }
  }
  .history{
    width: 100%;
    margin-bottom: 110px;
    .historyTitle{
      width: 100%;
      height: 63px;
      line-height: 40px;
      margin-bottom: 110px;
      color: #ed1c24;
      text-align: center;
      font-size: 33px;
        background: url(../assets/img/home/historyTitle.png) center no-repeat;
      letter-spacing: 12px;
    }
    .historyContent{
      width: 100%;
      text-align: center;
      .historyText{
        width: 1329px;
        display: flex;
        margin: 0 auto;
        text-align: left;
        font-size: 14.5px;
        letter-spacing: 1px;
      }
    }
  }
  .products{
    width: 100%;
    margin-bottom: 127px;
    .productsTitle{
      height: 57px;
      line-height: 40px;
      margin-bottom: 104px;
      color: #ed1c24;
      text-align: center;
      font-size: 33px;
      background:url(../assets/img/home/productsTitle.png) center no-repeat;
      letter-spacing: 12px;
    }
    .productsContent{
      width: 1580px;
      margin: 0 auto;
      display: flex;
      .productsLeft{
        width: 50%;
        height: 810px;
        background: url(../assets/img/home/productsLeft.png) no-repeat;
        background-size: 100%;
        box-sizing: border-box;
        padding-top: 184px;
        padding-left: 315px;
        z-index: 9999;
        .el-menu{
          width: 475px;
          background: none;
          li{
            width: 100%;
            height: 64px;
            padding-left: 74px!important;
            box-sizing: border-box;
            line-height: 64px;
            margin-bottom: 3px;
            background: #fff;
            font-size: 18px;
            letter-spacing: 1px;
            position: relative;
            -moz-transform: matrix( 0.26708628282612, -3.43538471001472e-16, 0, 0.26708628282612, 0, 0);
            -webkit-transform: matrix( 0.26708628282612, -3.43538471001472e-16, 0, 0.26708628282612, 0, 0);
            i{
              font-size: 50px;
              color: #ed1c24;
              position: absolute;
              right: -10px;
              top: 7px;
              display: none;
              z-index: 999;
            }
          }
          .is-active{
            background: #ed1c24;
          }
        }
      }
      .productsRight{
        width: 50%;
        background: #e7e7e7;
        padding-top: 73px;
        padding-left: 70px;
        padding-right: 40px;
        position: relative;
        .productsRightTitle{
          font-size: 28px;
          color: #ed1d25;
        }
        img{
          margin-left: 2px;
        }
        .productsRightContent{
          line-height: 28px;
          font-size: 14px;
          letter-spacing: 0.5px;
          text-indent: 2em;
          margin-top: 30px;
          padding-left: 2px;
          -moz-transform: matrix( 0.41508567794442, 0, -1.02698161563832e-15, 0.41508567794443, 0, 0);
          -webkit-transform: matrix( 0.41508567794442, 0, -1.02698161563832e-15, 0.41508567794443, 0, 0);

        }
      }
    }
  }
  .case{
    width: 100%;
    margin-bottom: 110px;
    .caseTitle{
      height: 61px;
      padding-left: 16px;
      box-sizing: border-box;
      line-height: 25px;
      margin-bottom: 104px;
      color: #ed1c24;
      text-align: center;
      font-size: 33px;
      letter-spacing: 12px;
      background:url(../assets/img/home/caseTitle.png) center no-repeat;
    }
    .caseContent{
      width: 995px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      align-items: center;
      &>div{
        width: 452px;
        height: 361px;
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 63px;
        position: relative;
      }
      .caseListTitle{
        width: 452px;
        height: 73px;
        background: #ed1d25;
        color: #fff;
        font-size: 19px;
        text-align: center;
        margin: 0;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .caseContentText{
        display: none;
        width: 100%;
        height:100%;
        padding:25px;
        box-sizing: border-box;
        background: rgba(237,29,37,0.8);
        color: #fff;
        position: absolute;
        top: 0;
        left: 0;
        cursor: pointer;
        div{
          color: #fff;
        }
        &>div:nth-child(1){
          font-size: 19px;
          margin-bottom: 30px;
          text-align: center;
        }
        &>div:nth-child(2){
          font-size: 14px;
          letter-spacing: 2px;
          text-indent: 2em;
          line-height: 20px;
        }
      }
      &>div:hover{
        .caseListTitle{
          background: rgba(237,29,37,0);
          color: rgba(0,0,0,0);
        }
        .caseContentText{
          display: block;
        }
      }
    }
    .caseMore{
      width: 1363px;
      margin: 0 auto;
      display: flex;
      justify-content: flex-end;
      a{
        width: 147px;
        height: 43px;
        background: #ed1d25;
        color: #fff;
        font-size: 19px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        text-decoration: none;
        i{
          font-size: 28px;
          color: #fff;
          margin-top: 4px;
        }

      }
    }
  }
  .qualification{
    width: 100%;
    margin-bottom: 150px;
    .qualificationTitle{
      height: 61px;
      padding-left: 16px;
      box-sizing: border-box;
      line-height: 25px;
      margin-bottom: 104px;
      color: #ed1c24;
      text-align: center;
      font-size: 33px;
      letter-spacing: 12px;
      background:url(../assets/img/home/title.jpg) center no-repeat;
    }
    .qualificationContent{
      display: flex;
      width: 1200px;
      margin: 0 auto;
      align-items: center;
      .prev{
        width: 50px;
        height: 90px;
        background: #ed1d25;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        i{
          color: #fff;
          font-size: 40px;
        }
      }
      .next{
        width: 50px;
        height: 90px;
        background: #ed1d25;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        i{
          color: #fff;
          font-size: 40px;
        }
      }
      .swiper-container{
        width: 1060px;
        margin: 0 auto;
        .swiper-slide {
          display: flex;
          flex-wrap: wrap;
          text-align: center;
          font-size: 18px;
          background: #fff;
          width: 100%;
          height: 100%;
          /* Center slide text vertically */
          display: -webkit-box;
          display: -ms-flexbox;
          display: -webkit-flex;
          display: flex;
          -webkit-box-pack: center;
          -ms-flex-pack: center;
          -webkit-justify-content: center;
          justify-content: center;
          -webkit-box-align: center;
          -ms-flex-align: center;
          -webkit-align-items: center;
          align-items: center;
          transition: 300ms;
          transform: scale(0.8);
        }

        .swiper-slide-active,
        .swiper-slide-duplicate-active {
          transform: scale(1);
        }
      }
    }

  }
   .news{
     width: 100%;
     margin-bottom: 150px;
     .news-more{
       width: 100%;
       display: flex;
       align-items: center;
       justify-content: flex-end;
       margin-bottom: 45px;
       margin-top: 45px;
     }
     .news-card-list{
       width: 100%;
       padding-left: 10%;
       display: flex;
     }
     .news_title{
       height: 61px;
       padding-left: 16px;
       box-sizing: border-box;
       line-height: 25px;
       margin-bottom: 80px;
       color: #ed1c24;
       text-align: center;
       font-size: 33px;
       letter-spacing: 12px;
       //background:url(../assets/img/news/img.png) center no-repeat;
     }
     .news_select{
       width: 100%;
       display: flex;
       align-items: center;
       justify-content: center;
       margin-bottom: 45px;
     }
   }
   .red{
     color: white;
     background: #ec1d25 ;
   }
  .radio-button{
    padding: 15px 60px;
    border: 1px solid #dcdfe6;
    cursor: pointer;
  }
</style>
